"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GracefulErrorByStatus = exports.GracefulError = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var default_error_1 = require("./default-error");
var hooks_1 = require("../hooks");
var decider_1 = require("./decider");
var GracefulError = function (props) {
    var _a;
    var _b = (0, hooks_1.useGraceful)(), errorInfo = _b.errorInfo, DefaultErrorComponent = _b.DefaultErrorComponent;
    return (((_a = errorInfo.get((0, hooks_1.createErrorInfoKey)(props))) === null || _a === void 0 ? void 0 : _a.errorComponent) ||
        DefaultErrorComponent || (0, jsx_runtime_1.jsx)(default_error_1.DefaultError, {}));
};
exports.GracefulError = GracefulError;
var GracefulErrorByStatus = function (_a) {
    var status = _a.status;
    var _b = (0, hooks_1.useGraceful)(), userComponentMap = _b.errorComponentMap, DefaultErrorComponent = _b.DefaultErrorComponent;
    return ((0, jsx_runtime_1.jsx)(decider_1.SelectErrorComponentWithStatusCode, __assign({}, {
        status: status,
        userComponentMap: userComponentMap,
        DefaultErrorComponent: DefaultErrorComponent,
    })));
};
exports.GracefulErrorByStatus = GracefulErrorByStatus;
